import React, { useEffect, useState } from 'react'
import "./NavbarStyles.css"
import { FaBars, FaTimes } from 'react-icons/fa'
import Logo from "./Logo"

const Navbar = () => {

  const [click, setClick] = useState(false);
  const [color, setColor] = useState(false);

  const handleClick = () => {
    setClick(!click)
  }

  const closeMenu = () => {
    setClick(false)
  }

  useEffect(() => {
    const changeColor = () => {
      setColor(window.scrollY >= 100);
    };

    window.addEventListener("scroll", changeColor);
    return () => window.removeEventListener("scroll", changeColor);
  }, []);

  return (
    <div className={color ? "header header-bg" : "header"}>
      <a href="#inicio">
        <Logo />
      </a>
      <ul className={click ? "nav-menu active" : "nav-menu"}>
        <li><a href="#inicio" onClick={closeMenu}>Inicio</a></li>
        <li><a href="#sobre-mi" onClick={closeMenu}>Sobre Mi</a></li>
        <li><a href="#proyectos" onClick={closeMenu}>Proyectos</a></li>
        <li><a href="#contacto" onClick={closeMenu}>Contacto</a></li>
      </ul>
      <div className='hamburger' onClick={handleClick}>
        {click ? (
          <FaTimes size={20} style={{ color: "var(--nudo-text)" }} />
        ) : (
          <FaBars size={20} style={{ color: "var(--nudo-text)" }} />
        )}
      </div>
    </div>
  )
}

export default Navbar
